var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"panel"},[_c('thead',[_c('tr',[_c('th',{staticClass:"header",attrs:{"colspan":"6"}},[_vm._v(_vm._s(_vm.selectedFacility)+" "+_vm._s(_vm.group))])])]),_c('tbody',[_vm._l((_vm.locations),function(loc){return [_c('BayPanel',{key:loc.id,attrs:{"bay":loc}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }